"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10CommonComponents = require("r10-common-components");
var _services = require("../../services");
var _PaymentOption = _interopRequireDefault(require("../shared/PaymentOption"));
var _useUpsellAccessoryState = _interopRequireDefault(require("../../hooks/upsell/useUpsellAccessoryState"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UpsellAccessoryCard = function UpsellAccessoryCard(_ref) {
  var index = _ref.index,
    product = _ref.product,
    onAddToCart = _ref.onAddToCart,
    onRemoveFromCart = _ref.onRemoveFromCart,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected;
  var _product$selectedVari = product.selectedVariant,
    name = _product$selectedVari.name,
    attachment = _product$selectedVari.attachment;
  var alteredPaymentOptions = product.paymentOptions.map(function (option, index) {
    return {
      label: /*#__PURE__*/_react.default.createElement(_PaymentOption.default, {
        price: option.label,
        key: index
      }),
      price: option.price
    };
  });
  var _useUpsellAccessorySt = (0, _useUpsellAccessoryState.default)(product, onAddToCart),
    addDisplayedUpsellProductDetails = _useUpsellAccessorySt.addDisplayedUpsellProductDetails,
    goToUpsellDetailsPage = _useUpsellAccessorySt.goToUpsellDetailsPage;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.AccessoryCard, {
    key: "".concat(product.name).concat(index),
    id: index,
    title: name,
    img: attachment[0].url,
    fallBackImage: 'https://store.storeimages.cdn-apple.com/4668/as-images.apple.com/is/MKUQ3_VW_34FR+watch-45-alum-midnight-nc-8s_VW_34FR_WF_CO_GEO_GB?wid=1400&hei=1400&trim=1%2C0&fmt=p-jpg&qlt=95&.v=1632171067000%2C1661968920898',
    paymentData: alteredPaymentOptions,
    isSelected: isSelected,
    addToCartCTA: {
      state: isDisabled ? 'disabled' : '',
      text: _services.locale.localeString('RelationshipOffer.AddToCart'),
      action: function action() {
        addDisplayedUpsellProductDetails(product);
        goToUpsellDetailsPage();
      }
    },
    removeFromCartCTA: {
      text: _services.locale.localeString('RelationshipOffer.RemoveFromCart'),
      action: function action() {
        onRemoveFromCart(product);
      }
    }
  }));
};
var _default = UpsellAccessoryCard;
exports.default = _default;